import React, { useState } from "react";
import queryString from "query-string";

import Form from "../components/Form";
import successIcon from "./icon_success.png";
import { useTranslation } from "react-i18next";

const ResetPassword = () => {
  const [formDone, setFormDone] = useState(false);
  const { t } = useTranslation();

  const parsed = queryString.parse(window.location.search);
  // console.log(parsed);
  const token = parsed.token;
  if (formDone) {
    return (
      <div className="content">
        <img src={successIcon} className="Leader-icon" alt={t('success')} />
        <h1>{t("change_password.success.title")}</h1>
        <p>{t("change_password.success.body.1")}</p>
        <></>
        <p>{t("change_password.success.body.2")}</p>
        <></>
        <p>{t("contact.title")}</p>
        <a href="tel:0800300766">{t("contact.body")}</a>
        <></>
        <p>
          {t("thank.1")}
          <br />
          {t("thank.2")}
        </p>
      </div>
    );
  } else {
    return (
      <div className="content">
        <h2>{t('change_password.fail.title')}</h2>
        <Form token={token} setFormDone={setFormDone} />
        <></>
        <p>{t('contact.title')}</p>
        <a href="tel:0800300766">{t('contact.body')}</a>
        <></>
        <p>
          {t('thank.1')} <br />
          {t('thank.2')} </p>
      </div>
    );
  }
};

export default ResetPassword;
